import { images } from ".";

const testimonials = [ 
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Andrew Jones', 
        title: 'Customer', 
        content: 'Renting a car was super easy and hassle-free. The vehicle was clean, well-maintained, and perfect for our road trip!',
    },
    {
        id: 2,
        image: images.testimonial2,
        name: 'Jenny Olson',
        title: 'Customer', 
        content: 'Excellent service and very professional staff. They helped me pick the right car and explained everything clearly.',
    },
    { 
        id: 3,
        image: images.testimonial3,
        name: 'Robert Anderson',
        title: 'Customer', 
        content: 'The entire rental process was smooth from start to finish. Highly recommend for anyone needing a reliable car quickly.', 
    },
    { 
        id: 4,
        image: images.testimonial4,
        name: 'Clare Nicholson',
        title: 'Customer', 
        content: 'I was impressed with the car selection and customer service. Booking online was simple and fast.', 
    },
];

export default testimonials;